import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

import Player from '~/Share/containers/Player';
import Sidebar from '~/Share/containers/Sidebar';
import SideShare from '~/Share/components/Share/SideShare';
import ShareButton from '~/Share/components/NextGen/ShareButton';
import { ReduxState } from '~/types/redux/share';
import { SentWithBonjoroBadgeStyle } from '@vimily/bonjoro-ui-components-v2';
import {
  addUtmToLink,
  UTM_SOURCE_GREET_SHARE_PAGE,
  UTM_CAMPAIGN_GREET_REFERRALS,
  UTM_MEDIUM_HEADER_BADGE,
} from '~/utils/add-utm-to-link';
import { useMedia } from 'react-use-media';
import { BonjoroBadgeDesktop } from '~/App/Components/BonjoroBadgeDesktop';

const ShareButtonContainer = styled.div`
  height: 32px;
  width: 32px;
  position: fixed;
  top: 15px;
  right: 15px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgb(0 0 0 / 25%);
  cursor: pointer;
  z-index: 1;
  padding: 5px;
`;

export type PostCardProps = {
  slug: string;
  showShareButtons?: boolean;
};

export default function Postcard({ slug, showShareButtons }: PostCardProps) {
  const {
    isRecipient,
    thumbUrl,
    videoUrl,
    transcript,
    messageTemplate,
    features,
  } = useSelector((state: ReduxState) => ({
    isRecipient: state.root.isRecipient,
    thumbUrl: state.root.model.thumb_url,
    videoUrl: state.root.model.video_url,
    transcript: state.root.model.transcript,
    messageTemplate: state.root.messageTemplate,
    features: state.root.features,
  }));

  const { shouldHideBonjoroBranding } = features;
  const isMobile = useMedia({
    maxWidth: 950,
  });

  return (
    <>
      {showShareButtons && (
        <ShareButtonContainer>
          <ShareButton className='lg:flex' />
        </ShareButtonContainer>
      )}
      <div className='box-inner'>
        <div className='box-video !bg-transparent'>
          <Player
            videoUrl={videoUrl}
            thumbUrl={thumbUrl}
            showReactionButton={isRecipient}
            transcript={transcript}
            videoPlayerContainerClassname='rounded-none md:rounded-[10px] min-[950px]:rounded-r-none w-full h-full'
            primaryColor={messageTemplate.primary_color}
            showBonjoroBadge={isMobile && !shouldHideBonjoroBranding}
          />
        </div>
        <Sidebar />
        {showShareButtons && <SideShare slug={slug} />}
      </div>
      {!isMobile && !features.shouldHideBonjoroBranding && (
        <BonjoroBadgeDesktop
          style={SentWithBonjoroBadgeStyle.Full}
          url={addUtmToLink('/', {
            utm_source: UTM_SOURCE_GREET_SHARE_PAGE,
            utm_medium: UTM_MEDIUM_HEADER_BADGE,
            utm_campaign: UTM_CAMPAIGN_GREET_REFERRALS,
          })}
        />
      )}
    </>
  );
}
